import { EnumTagSemanticoDTOTipo } from '@framework/api-client/api/users/schemas/enumTagSemanticoDTOTipo.ts';
import { type TagSemanticoDTO } from '@framework/api-client/api/users/schemas/tagSemanticoDTO.ts';

export class SemanticTagLogic {
  /**
   * Ritorna true per tutti quei tag semantici che sono visibili nei dettagli di una entità.
   * e.g. la lista dei tag semantici nel dettaglio rihiesta inviata.
   *
   * NB: i tag di tipo geometria sono *sempre nascosti*.
   */
  static isVisible(semanticTag: TagSemanticoDTO | null | undefined) {
    if (!semanticTag) return false;
    return (
      semanticTag.flVisualizzabile &&
      semanticTag.tipo !== EnumTagSemanticoDTOTipo.GEOMETRY &&
      semanticTag.tipo !== EnumTagSemanticoDTOTipo.MAPPA &&
      semanticTag.tipo !== EnumTagSemanticoDTOTipo.FILE
    );
  }
}
